import React, { useMemo } from 'react';
import { Steps } from '~/ui/components';
import { Ticket, TicketFile } from '~/typings/entities/Ticket';

import { TicketForm } from './TicketForm/TicketForm';
import { TicketResume } from './TicketResume/TicketResume';

type TicketFileData = {
  id: string;
  disableRemoveButton?: boolean;
  file: {
    name: string;
    url: string;
    size: number;
  };
};

export type TicketData = {
  ticket: Partial<Ticket>;
  files?: TicketFileData[];
  contractsChanged?: boolean;
};

interface ITicketModalProps {
  isUpdating?: boolean;
  ticket?: Partial<Ticket>;
  readOnlyFields?: string[];
  companyId?: number;
}

function formatFiles(files?: TicketFile[]): TicketFileData[] {
  return files?.map((file: TicketFile) => ({
    id: `${file.ticketId}-${file.fileName}`,
    disableRemoveButton: true,
    file: {
      name: file.fileName,
      url: file.url,
      size: file.fileSize,
    },
  }));
}

export function TicketModal({ isUpdating, ticket, readOnlyFields, companyId }: ITicketModalProps) {
  const files = formatFiles(ticket?.ticketFiles?.files);

  const [data, setData] = React.useState<TicketData>({ ticket, files });

  const effectiveCompanyId = companyId ?? ticket?.companyId;

  const steps = useMemo(
    () => [
      {
        id: 'TICKET_FORM',
        component: (
          <TicketForm
            title="Registre seu ticket"
            setData={setData}
            data={data}
            isUpdating={isUpdating}
            readOnlyFields={readOnlyFields}
            companyId={effectiveCompanyId}
          />
        ),
      },
      {
        id: 'TICKET_RESUME',
        component: <TicketResume buttonText="Registrar" data={data} isUpdating={isUpdating} />,
      },
    ],
    [isUpdating, setData, data, readOnlyFields, effectiveCompanyId],
  );

  return <Steps steps={steps} />;
}
